import type { RouteRecordRaw } from 'vue-router';
import SectionListPage from './pages/SectionListPage/SectionListPage.vue';
import SectionStepsPage from './pages/SectionStepsPage/SectionStepsPage.vue';
import SectionStepPage from './pages/SectionStepPage/SectionStepPage.vue';
import SectionAssignedPage from './pages/SectionAssignedPage/SectionAssignedPage.vue';
import SectionStudentMyPage from './pages/SectionStudentMyPage/SectionStudentMyPage.vue';

export const main: RouteRecordRaw[] = [
  {
    name: 'sections',
    path: 'sections',
    component: SectionListPage,
    meta: {
      requriesAuth: true,
      headerTitle: 'MY_SECTIONS',
    },
  },
  {
    name: 'sections.assigned',
    path: 'sections/assigned',
    component: SectionAssignedPage,
    meta: {
      requriesAuth: true,
      headerTitle: 'ASSIGNED_SECTIONS',
    },
  },
  {
    name: 'sections.my.student',
    path: 'sections/my/student',
    component: SectionStudentMyPage,
    meta: {
      requriesAuth: true,
      headerTitle: 'MY_SECTIONS',
    },
  },
  {
    name: 'section.steps',
    path: 'section/:userSectionDocId',
    component: SectionStepsPage,
    meta: {
      requriesAuth: true,
    },
  },
  {
    name: 'section.steps.step',
    path: 'section/:userSectionDocId/step/:userStepId/:stepDocId',
    component: SectionStepPage,
    meta: {
      requriesAuth: true,
    },
  },
];

export const base: RouteRecordRaw[] = [];
